import { render, staticRenderFns } from "./DatatableBalance.vue?vue&type=template&id=afbaa50e&"
import script from "./DatatableBalance.vue?vue&type=script&lang=js&"
export * from "./DatatableBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports